import { useState } from "react";
import type { ChangeEvent } from "react";
import Accordion from "react-bootstrap/Accordion";
import ActionButton from "./formInputs/buttons/ActionButton";
import T, { GetLang } from "./translations/Translations";
import { GUARDIAN_DASHBOARD } from "@utils/auth/config";

const NewUserStartForm = (): JSX.Element => {
    const lang = GetLang();
    const [formStart, setFormStart] = useState(false);
    const [hasUsernameAndPassword, setHasUsernameAndPassword] = useState<boolean | null>(null);
    const [newToDistrict, setNewToDistrict] = useState<boolean | null>(null);

    // Translations
    const welcomeCreateAccount = T({ tKey: "Welcome_Create_Account", langStr: lang });
    const welcomeLogIn = T({ tKey: "Welcome_Log_In", langStr: lang });
    const welcomeContactChoiceProgramming = T({ tKey: "Welcome_Contact_Choice_Programming", langStr: lang });
    const welcomeNo = T({ tKey: "Welcome_No", langStr: lang });
    const welcomeYes = T({ tKey: "Welcome_Yes", langStr: lang });
    const welcomeUandP = T({ tKey: "Welcome_U_And_P", langStr: lang });
    const welcomeNewToDistrict = T({ tKey: "Welcome_New_To_District", langStr: lang });
    const welcomeStartHere = T({ tKey: "Welcome_Start_Here", langStr: lang });
    const welcomeCaution = T({ tKey: "Welcome_Caution", langStr: lang });

    const goToDashboard = (): void => {
        globalThis.location.href = GUARDIAN_DASHBOARD;
    };

    const goToFischer = (): void => {
        globalThis.location.href =
            "https://iaas5idm.fischeridentity.com/identity/self-service/dcs/selfreg.jsf?type=ExternalGuardian";
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
        const { checked, name, value } = e.target;
        const booleanValue = value === "true";
        if (name === "new-to-district" && checked) {
            setHasUsernameAndPassword(null);
            setNewToDistrict(booleanValue);
        } else if (name === "has-username-and-password" && checked) {
            setHasUsernameAndPassword(booleanValue);
        }
    };

    return (
        <div className="start-form">
            {formStart ? (
                <div className="welcome-text-container">
                    <Accordion defaultActiveKey={["6"]} alwaysOpen>
                        <Accordion.Item eventKey="6">
                            <Accordion.Header>
                                <h5>{welcomeNewToDistrict}</h5>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div className="part1">
                                    <label className="d-block">
                                        <input
                                            checked={newToDistrict === true}
                                            id="new-to-district-yes"
                                            name="new-to-district"
                                            onChange={handleChange}
                                            type="radio"
                                            value="true"
                                        />
                                        <span className="ms-2">{welcomeYes}</span>
                                    </label>
                                    <label className="d-block">
                                        <input
                                            checked={newToDistrict === false}
                                            id="new-to-district-no"
                                            name="new-to-district"
                                            onChange={handleChange}
                                            type="radio"
                                            value="false"
                                        />
                                        <span className="ms-2">{welcomeNo}</span>
                                    </label>
                                </div>
                                {newToDistrict === false && (
                                    <>
                                        <div className="part2 mt-4">
                                            <hr />
                                            <span className="form-header">{welcomeUandP}</span>
                                            <br />
                                            <br />
                                            <label className="d-block">
                                                <input
                                                    checked={hasUsernameAndPassword === true}
                                                    id="has-username-and-password-yes"
                                                    name="has-username-and-password"
                                                    onChange={handleChange}
                                                    type="radio"
                                                    value="true"
                                                />
                                                <span className="ms-2">{welcomeYes}</span>
                                            </label>
                                            <label className="d-block">
                                                <input
                                                    checked={hasUsernameAndPassword === false}
                                                    id="has-username-and-password-no"
                                                    name="has-username-and-password"
                                                    onChange={handleChange}
                                                    type="radio"
                                                    value="false"
                                                />
                                                <span className="ms-2">{welcomeNo}</span>
                                            </label>
                                        </div>
                                        {hasUsernameAndPassword === false && (
                                            <div className="mt-2 danger">{welcomeContactChoiceProgramming}</div>
                                        )}
                                        {hasUsernameAndPassword === true && (
                                            <div className="mt-4">
                                                <ActionButton label={welcomeLogIn} onClick={goToDashboard} />
                                            </div>
                                        )}
                                    </>
                                )}
                                {newToDistrict === true && (
                                    <div className="mt-2 danger">
                                        {welcomeCaution}
                                        <div className="mt-4">
                                            <ActionButton label={welcomeCreateAccount} onClick={goToFischer} />
                                        </div>
                                    </div>
                                )}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            ) : (
                <ActionButton
                    className="btn btn-primary"
                    label={welcomeStartHere}
                    onClick={() => {
                        setFormStart(true);
                    }}
                />
            )}
        </div>
    );
};

export default NewUserStartForm;
